<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="10" md="8">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.subCultureId"
          v-bind="getObject('subCultureId')"
          label="Sub Cultura"
          :items="extraData.globalContext.allSubCultures"
          @change="selectSubCulture"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
          :hint="entry.subCulture ? entry.subCulture.additionalInfo : '' "
          persistent-hint
        >
          <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title>{{data.item.name}}</v-list-item-title>
            <v-list-item-subtitle>{{data.item.additionalInfo}}</v-list-item-subtitle>
          </v-list-item-content>
        </template>

          <template v-slot:append-outer>
            <SubCultureNew
              :inlineAddButton="true"
              @entry-created="subCultureCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import SubCultureNew from "@models/sub_cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    SubCultureNew: SubCultureNew,   
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if (this.entry && this.entry.subCultureId) {
      this.selectSubCulture();
    }
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  methods: {
    selectSubCulture: function() {
      if (this.entry.subCultureId) {
        this.entry.subCulture = this.extraData.globalContext.allSubCultures.find(obj => obj.id == this.entry.subCultureId);
      }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    subCultureCreated: function(subCulture) {
      this.extraData.globalContext.allSubCultures.unshift(subCulture);
      this.entry.subCultureId = subCulture.id;
      this.entry.subCulture = subCulture;
    },
  }
};
</script>

<style scoped></style>
